import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Navbar from "components/blocks/Navbar";
import Footer from "components/sections/Footer";
import PrivacyPolicyConsent from "components/blocks/PrivacyPolicyConsent";
import PreorderCountdownBanner from "components/blocks/PreorderCountdownBanner";
import { isExcludedRoute } from "lib/excludedRoutes";
import { MotionBox } from "utils/motion";

const pageEnterVariants = {
  enter: { opacity: 1, transition: { duration: 0.2 } },
  initial: { opacity: 0, transition: { duration: 0.2 } },
};

// The enter fade is a route-transition effect. Running it on the very first
// mount hides the already-painted SSR markup behind a 200ms opacity ramp,
// which reads as the page flashing black on a cold load (incognito, no cache).
let hasMountedOnce = false;

const MainContainer = (props) => {
  const {
    children,
    navStyle,
    footerSmall,
    updateVisible,
    style,
    noFooter,
    noMenu,
    noNewsletter,
    customBar,
    mandatoryFooter,
    bg,
    hideNav,
  } = props;

  const [animateEnter] = useState(() => hasMountedOnce);
  const { asPath } = useRouter();

  useEffect(() => {
    hasMountedOnce = true;
  }, []);

  // Transactional, account and campaign-funnel pages carry their own CTAs.
  const showCountdownBanner = !isExcludedRoute(asPath);

  return (
    <MotionBox bg={bg ? bg : "black.900"}>
      {customBar || <Navbar initialized isFixed forceHide={hideNav} />}
      <Navbar
        initialized
        hasGradient={navStyle.gradient}
        isInverted={navStyle.inverted}
        noMenu={noMenu}
        forceHide={hideNav}
      />
      <MotionBox
        initial={animateEnter ? "initial" : false}
        animate="enter"
        variants={pageEnterVariants}
        style={style}
      >
        {children}
        {!noFooter && (
          <Footer
            small={footerSmall}
            updateVisible={updateVisible}
            noNewsletter={noNewsletter}
            mandatoryFooter={mandatoryFooter}
            {...props}
          />
        )}
      </MotionBox>
      <PrivacyPolicyConsent />
      {showCountdownBanner && <PreorderCountdownBanner />}
    </MotionBox>
  );
};

export default MainContainer;
